"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
const tslib_1 = require("tslib");
const mobx_localstorage_1 = tslib_1.__importDefault(require("mobx-localstorage"));
const index_1 = require("./index");
exports.LocalStorage = mobx_localstorage_1.default;
/**
 * Make a ParseStorageKey
 */
mobx_localstorage_1.default.storageKey = function storageKey(key) {
    if (index_1.Services.Config.env == null) {
        throw new Error('No ApplicationId');
    }
    return ['Parse', `dragon-${index_1.Services.Config.env}`, key].join('/');
};
mobx_localstorage_1.default.__priority = 10;
//# sourceMappingURL=observable.storage.js.map